import { v4 as uuidv4 } from 'uuid';
import {
  assignIfExists,
  assignProps,
  findWithReadStatus,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { userGroupLists, createUsergroupActions } from '../constants';
import {
  activeUserGroup,
  findUserGroup,
  newUserGroupProperties,
  openUserGroup,
} from './state';

const createUsergroup = withDraft((draft) => { draft.activeUserGroup.saveStatus = states.PENDING; });

const createUsergroupSuccess = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  draft.activeUserGroup = activeUserGroup();
  item.previousCode = item.code;
  item.copy = {};

  assignProps(item, {
    ...action.result,
    saveStatus: states.SUCCESS,
    saveErrors: [],
    readStatus: states.SUCCESS,
    readErrors: [],
    isDirty: false,
    isEditing: false,
    isNew: false,
  });

  findWithReadStatus(draft.userGroups, userGroupLists, states.SUCCESS).forEach((category) => {
    draft.userGroups[category].readStatus = states.PENDING;
    draft.userGroups[category].readErrors = [];
  });
});

const createUsergroupError = withDraft((draft, action) => {
  assignIfExists(draft.activeUserGroup, {
    saveStatus: states.ERROR,
    saveErrors: [responseError(action)],
  });
});

const newUserGroupFromSource = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  if (!item) {
    draft.newUserGroupCode = uuidv4();
    draft.userGroups[action.category].results.push(openUserGroup(action));
  }
});

const showSaveUsergroupDialog = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  assignProps(draft.activeUserGroup, newUserGroupProperties(item));
  draft.activeUserGroup.open = true;
});

const hideSaveUsergroupDialog = withDraft((draft) => { draft.activeUserGroup = activeUserGroup(); });

export default {
  [createUsergroupActions.CREATE_USERGROUP]: createUsergroup,
  [createUsergroupActions.CREATE_USERGROUP_ERROR]: createUsergroupError,
  [createUsergroupActions.CREATE_USERGROUP_SUCCESS]: createUsergroupSuccess,
  [createUsergroupActions.HIDE_SAVE_USERGROUP_DIALOG]: hideSaveUsergroupDialog,
  [createUsergroupActions.NEW_USERGROUP_FROM_SOURCE]: newUserGroupFromSource,
  [createUsergroupActions.SHOW_SAVE_USERGROUP_DIALOG]: showSaveUsergroupDialog,
};
